export default __webpack_public_path__ + "static/media/eightPieces6.88afb90c.jpg";